import { OnInit, Component } from '@angular/core';
import { SubHeader } from '../../../../core/models/sub-header.model';
//import { AllModules, GridOptions, ColDef, ValueFormatterParams } from '@ag-grid-enterprise/all-modules';
import { GridOptions, ColDef, ValueFormatterParams, GridApi } from "ag-grid-community";
import { DateService } from '../../../../common/services/date.service';
import { Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';
import { GridFormatterService } from '../../../../common/services/grid-formatter.service';
import { Router } from '@angular/router';
import { SubHeaderService } from '../../../../core/services/sub-header.service';
import { tap } from 'rxjs/operators';
import { AdminReportsService } from '../../../services/admin-reports.service';
import { BondSearchCriteria, SurplusInsurerModel } from '../../../models/admin-reports.model';
import { dateComparator } from '../../../../common/components/data-table/comparators/data-table.comparators';
import { ReportArgs } from "../../../../common/models/reports.model";



@Component({
    selector: 'app-surplus-insurer-report',
    templateUrl: './surplus-insurer-report.component.html',
    styleUrls: ['./surplus-insurer-report.component.scss'],
    standalone: false
})
export class SurplusInsurerReportComponent implements OnInit {
    surplusInsurer: SurplusInsurerModel[]
    gridOptions: GridOptions;
	gridApi?: GridApi;
    currentDate: Date = new Date();

    toDate: Date | null;
    fromDate: Date | null;

    get invalidDateCombination(): boolean {
        let invalid: boolean = false;
        if (this.toDate == null || this.fromDate == null) {
            invalid = true;
        } else if (this.toDate != null && this.fromDate != null) {
            invalid = this.toDate < this.fromDate;
        }

        return invalid;
    }

    subHeader: SubHeader = new SubHeader({
        title: "Surplus Insurers Listing of Owners",
        buttons: []
    });

    subscription: Subscription = new Subscription();

    constructor(
        private datePipe: DatePipe,
        private readonly dateService: DateService,
        private readonly formatService: GridFormatterService,
        private readonly faService: AdminReportsService,
        public router: Router,
        public subHeaderService: SubHeaderService
	) { }

    ngOnInit() {
        this.subHeaderService.updateSubHeader(this.subHeader);
        this.fromDate = this.dateService.generateDateWithOffset(0, -1, 0);
        this.toDate = this.currentDate;

        let coldefs = this.createColumnDefinitions();
        this.gridOptions = this.formatService.BuildDefaultGridOptionsWithColumns(coldefs, false, true, true, true);        
		this.gridOptions.onGridReady = (params) => { 
            this.gridApi = params.api; 
            this.onGridReady(params);
        };
        this.generateReport({ fromDate: this.fromDate, toDate: this.toDate, download: false } as ReportArgs);
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    fromDateChanged(model: Date): void {
        this.fromDate = model;
    }

    toDateChanged(model: Date): void {
        this.toDate = model;
    }

    generateReport(args: ReportArgs) {
        this.fromDate = args.fromDate;
        this.toDate = args.toDate;
        if (this.gridApi) {
            this.gridApi.setGridOption("loading", true);
        }
        const criteria = new BondSearchCriteria();
        criteria.fromDate = this.fromDate;
        criteria.toDate = this.toDate;
        criteria.isActive = true;
        this.subscription = this.faService.getSurplusInsurerInfo(criteria).pipe(
            tap((data) => {
                this.surplusInsurer = data;
            })).subscribe({
                next: (success) => {
                    if (this.gridApi != null) {
                        this.gridApi.setGridOption("rowData", this.surplusInsurer);
                        this.gridApi.setGridOption("loading", false);                
                        this.gridApi.sizeColumnsToFit();     
                    }           
                }, 
                error: (fail) => {
                    console.error(fail);
                    if (this.gridApi != null) {
                        this.gridApi.setGridOption("loading", false);
                    }
                }
            });

    };

    downloadReport(args: ReportArgs) {
        this.fromDate = args.fromDate;
        this.toDate = args.toDate;
        const frmDt = this.datePipe.transform(this.fromDate, "yyyy-MM-dd").toString();
        const toDt = this.datePipe.transform(this.toDate, "yyyy-MM-dd").toString();

        const fileName = `SurplusInsurersOwnersListing_${frmDt.toString()}_${toDt.toString()}`;
        const sheetName = "Surplus Insurer";

        this.formatService.exportDataToExcel(fileName, sheetName, this.gridApi);
    }

    public createColumnDefinitions() {
        return [

            {
                headerName: "Owner Name",
                headerTooltip: "Owner Name",
                field: "ownerName",
                tooltipField: 'ownerName', 
                filter: "agTextColumnFilter",
                filterParams: this.formatService.defaultTextFilterParams,
            },
            {
                headerName: "Owner Number",
                headerTooltip: "Owner Number",
                field: "ownerNumber",
                tooltipField: 'ownerNumber',
                filter: "agTextColumnFilter",
                filterParams: this.formatService.defaultTextFilterParams,
            },
            {
                headerName: "Insurer",
                headerTooltip: "Insurer",
                field: "insurer",
                tooltipField: 'insurer',
                filter: "agTextColumnFilter",
                filterParams: this.formatService.defaultTextFilterParams,
            },
            {
                headerName: "Insurer Agent Name",
                headerTooltip: "Insurer Agent Name",
                field: "insurerAgentName",
                tooltipField: 'insurerAgentName',
                filter: "agTextColumnFilter",
                filterParams: this.formatService.defaultTextFilterParams,
            },
            {
                headerName: "Amount",
                headerTooltip: "Amount",
                field: "insuranceAmount",
                tooltipValueGetter: this.formatService.formatCurrency("insuranceAmount", "USD", "symbol", "1.2-2"),
                valueFormatter: this.formatService.formatCurrency("insuranceAmount", "USD", "symbol", "1.2-2"),
                filter: "agNumberColumnFilter",
                filterParams: this.formatService.defaultNumberFilterParams
            } as ColDef,
            {
                headerName: "Effective Date",
                headerTooltip: "Effective Date",
                field: "effectiveDate",
                tooltipValueGetter: this.formatService.formatDate("effectiveDate"),
                valueGetter: this.formatService.formatDate("effectiveDate"),
                comparator: dateComparator,
                filter: "agDateColumnFilter",
                filterParams: this.formatService.defaultDateFilterParams,
            },
            {
                headerName: "Expiration Date",
                headerTooltip: "Expiration Date",
                field: "expirationDate",
                tooltipValueGetter: this.formatService.formatDate("expirationDate"),
                valueGetter: this.formatService.formatDate("expirationDate"),
                comparator: dateComparator,
                filter: "agDateColumnFilter",
                filterParams: this.formatService.defaultDateFilterParams,                 
            }
           
        ] as ColDef[];
    }

    onGridReady(event: any) {
        this.formatService.gridReadySizeToFit(event);
    }

    onGridPageChanged(event: any) {
        if (this.gridApi != null) {
            this.gridApi.sizeColumnsToFit();
        }
    }

	processCallback(params: any): string {
		const colDef: ColDef = params.column.getColDef();
		if (colDef.valueFormatter) {
			const valueFormatterParams: ValueFormatterParams = {
				...params,
				data: params.node.data,
				node: params.node!,
				colDef: params.column.getColDef()
			};
			if (typeof colDef.valueFormatter === 'function') {
				return colDef.valueFormatter(valueFormatterParams);
			} else {
				return colDef.valueFormatter;
			}
		}
		return params.value;
	}
}
